import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAirdropArrow, LazySvgoAirdropDone, LazySvgoAirdropIcFuturesAccount, LazySvgoAirdropIcGonggao, LazySvgoAirdropIcHelp, LazySvgoAirdropIcLanguage, LazySvgoAirdropIcNotebook, LazySvgoAirdropIcTelegram, LazySvgoAirdropIcX, LazySvgoApiManagementAdd, LazySvgoApiManagementWarning, LazySvgoAssetsIcAlert, LazySvgoAssetsIcCheck, LazySvgoAssetsIcEdit, LazySvgoAssetsIcNotebook, LazySvgoAssetsStatusSuccess, LazySvgoAssetsWithdrawIcFail, LazySvgoAssetsWithdrawIcSuccess, LazySvgoCommonAppLightLogo, LazySvgoCommonAppLogo, LazySvgoCommonArrowDown, LazySvgoCommonArrowRight, LazySvgoCommonArrowUp, LazySvgoCommonArrow, LazySvgoCommonBtnLoading, LazySvgoCommonCheckCircle, LazySvgoCommonCheck, LazySvgoCommonCodeQr, LazySvgoCommonCopy, LazySvgoCommonCopy2, LazySvgoCommonCopy3, LazySvgoCommonDateIcon, LazySvgoCommonDelete, LazySvgoCommonDownload, LazySvgoCommonError, LazySvgoCommonEyeClose, LazySvgoCommonEye, LazySvgoCommonFilter, LazySvgoCommonFire, LazySvgoCommonGuide, LazySvgoCommonIconChevronDown, LazySvgoCommonIconClear, LazySvgoCommonIconFavTrade, LazySvgoCommonIconLogoQrWhite, LazySvgoCommonIconNotice, LazySvgoCommonIconSearch, LazySvgoCommonIconTip, LazySvgoCommonIconLogoQr, LazySvgoCommonLoading, LazySvgoCommonModalHint, LazySvgoCommonNoDataDark, LazySvgoCommonNoDataSearchDark, LazySvgoCommonNoDataSearch, LazySvgoCommonNoData, LazySvgoCommonPagiationArrow, LazySvgoCommonSearchClear, LazySvgoCommonSelectArrow, LazySvgoCommonSolidTriangle, LazySvgoCommonSuccess, LazySvgoCommonThemeDark, LazySvgoCommonThemeLight, LazySvgoCommonUsdt, LazySvgoCommonWaring2, LazySvgoCommonWarning, LazySvgoCommonWarning3, LazySvgoContestArrowRight, LazySvgoContestAttention, LazySvgoContestCopy, LazySvgoContestCopyLink, LazySvgoContestDownload, LazySvgoContestFacebook, LazySvgoContestIcInfo, LazySvgoContestIconDown, LazySvgoContestLogo, LazySvgoContestOngoing, LazySvgoContestShare, LazySvgoContestTg, LazySvgoContestTwitter, LazySvgoFooterArrow, LazySvgoFooterFacebook, LazySvgoFooterLinkedin, LazySvgoFooterMedium, LazySvgoFooterTelegram, LazySvgoFooterTiktok, LazySvgoFooterX, LazySvgoFooterYoutube, LazySvgoFuturesBonus, LazySvgoFuturesBonusPosition, LazySvgoFuturesCalculator, LazySvgoFuturesDeliveringDark, LazySvgoFuturesDelivering, LazySvgoFuturesHelp, LazySvgoFuturesIconStatusAlert, LazySvgoFuturesIconTelegram, LazySvgoFuturesIconTpslEdit, LazySvgoFuturesIconX, LazySvgoFuturesKlineArea, LazySvgoFuturesKlineBars, LazySvgoFuturesKlineBaseline, LazySvgoFuturesKlineCandle, LazySvgoFuturesKlineHeikinAshi, LazySvgoFuturesKlineHilo, LazySvgoFuturesKlineHollowCandle, LazySvgoFuturesKlineKagi, LazySvgoFuturesKlineLineBreak, LazySvgoFuturesKlineLine, LazySvgoFuturesKlinePointFigure, LazySvgoFuturesKlineRenko, LazySvgoFuturesMinusSign, LazySvgoFuturesModalInfo, LazySvgoFuturesPauseDark, LazySvgoFuturesPause, LazySvgoFuturesPlusSign, LazySvgoFuturesResetLayout, LazySvgoFuturesRiskWidgetBg, LazySvgoFuturesRiskWidgetPointer, LazySvgoFuturesSetting, LazySvgoFuturesTransferArrow, LazySvgoFuturesTransferFuture, LazySvgoFuturesTransferSpot, LazySvgoFuturesTransferTrialfund, LazySvgoFuturesTransfer, LazySvgoHeaderIconAccount, LazySvgoHeaderIconApi, LazySvgoHeaderIconApply, LazySvgoHeaderIconArrowRight, LazySvgoHeaderIconCard, LazySvgoHeaderIconChecked, LazySvgoHeaderIconClose, LazySvgoHeaderIconContest, LazySvgoHeaderIconDeposit, LazySvgoHeaderIconFee, LazySvgoHeaderIconFund, LazySvgoHeaderIconFuturesAsset, LazySvgoHeaderIconFutures, LazySvgoHeaderIconInvite, LazySvgoHeaderIconLaunchpool, LazySvgoHeaderIconLogout, LazySvgoHeaderIconNewAPI, LazySvgoHeaderIconOrder, LazySvgoHeaderIconPerpetual, LazySvgoHeaderIconSpotAsset, LazySvgoHeaderIconSpot, LazySvgoHeaderIconTotalAsset, LazySvgoHeaderIconTransfer, LazySvgoHeaderIconUser, LazySvgoHeaderIconWallet, LazySvgoHeaderIconWithdraw, LazySvgoHomeArrow, LazySvgoHomeBanner, LazySvgoHomeFutures, LazySvgoHomeHot, LazySvgoHomeIcAndroid, LazySvgoHomeIcApple, LazySvgoHomeIcMore, LazySvgoHomeIcNotice, LazySvgoHomeIcQrcode, LazySvgoHomeIcClose, LazySvgoHomeIcOpen, LazySvgoHomeIcRightArrow, LazySvgoHomeIcService, LazySvgoHomeIconMore, LazySvgoHomeLogo, LazySvgoHomeQrcode, LazySvgoHomeService, LazySvgoHomeSpot, LazySvgoHomeStep1, LazySvgoHomeStep2, LazySvgoHomeStep3, LazySvgoHomeSupport, LazySvgoHomeTop, LazySvgoHomeTrademethodsIcArrow, LazySvgoHomeTrademethodsIcContest, LazySvgoHomeTrademethodsIcFutures, LazySvgoHomeTrademethodsIcInvite, LazySvgoHomeTrademethodsIcSpot, LazySvgoInviteFriendsFailed, LazySvgoInviteFriendsSuccess, LazySvgoInviteFriendsVerify, LazySvgoJoinUsX, LazySvgoJoinUsGroup, LazySvgoJoinUsTg, LazySvgoKycAdd, LazySvgoKycCardBlackBg, LazySvgoKycCardWhiteBg, LazySvgoKycDone, LazySvgoKycIdCard, LazySvgoKycPhone, LazySvgoKycUpload, LazySvgoLaunchpoolAdd, LazySvgoLaunchpoolIcClear, LazySvgoLaunchpoolIcClock, LazySvgoLaunchpoolIcDownload, LazySvgoLaunchpoolIcHelp, LazySvgoLaunchpoolIcLeft, LazySvgoLaunchpoolIcMenu, LazySvgoLaunchpoolIcNotes, LazySvgoLaunchpoolIcRights, LazySvgoLaunchpoolIcRightsText, LazySvgoLaunchpoolIcRule, LazySvgoLaunchpoolIconTrade, LazySvgoLaunchpoolOfficialSite, LazySvgoLaunchpoolTagComingSoon, LazySvgoLaunchpoolTagEnd, LazySvgoLaunchpoolTagOnGoing, LazySvgoLaunchpoolTwitter, LazySvgoLaunchpoolX, LazySvgoLinksHeader, LazySvgoMarketDarkSelected, LazySvgoMarketDarkUnselected, LazySvgoMarketFavorite, LazySvgoMarketFuture, LazySvgoMarketLightSelected, LazySvgoMarketLightUnselected, LazySvgoMarketNoStar, LazySvgoMarketSearch, LazySvgoMarketSpots, LazySvgoMarketStar, LazySvgoMyIconsAccounts, LazySvgoMyIconsAssets, LazySvgoMyIconsDeposit, LazySvgoMyIconsOrders, LazySvgoMyIconsWithdraw, LazySvgoMyWalletFuture, LazySvgoMyWalletRecord, LazySvgoMyWalletSpot, LazySvgoReferralArrow, LazySvgoReferralIcHow1, LazySvgoReferralIcHow2, LazySvgoReferralIcHow3, LazySvgoReferralIcQrCode, LazySvgoReferralLogo, LazySvgoSignUpArrow, LazySvgoSignUpCheck, LazySvgoSignUpClose, LazySvgoSignUpCountryArrow, LazySvgoSignUpEyeClose, LazySvgoSignUpEyeOpen, LazySvgoSignUpPass, LazySvgoSpotBg, LazySvgoSpotIcAdd, LazySvgoSpotIcAttention, LazySvgoSpotIcCalculatorS, LazySvgoSpotIcFire, LazySvgoSpotIcHistory, LazySvgoSpotIcProfitSharing, LazySvgoSpotIcWebsite, LazySvgoSpotIcWhitePaper, LazySvgoSpotIcZoomout, LazySvgoSpotIconCamera, LazySvgoSpotIconFullscreen, LazySvgoSpotIconIcRight, LazySvgoSpotIconIndicators, LazySvgoSpotIconSetting, LazySvgoTokenListingApplyArrow, LazySvgoTokenListingApplySelected, LazySvgoUserAdvancedcertification, LazySvgoUserAlert, LazySvgoUserApple, LazySvgoUserBasiccertification, LazySvgoUserCertificationstatus, LazySvgoUserCheck, LazySvgoUserCircle, LazySvgoUserClose, LazySvgoUserDel, LazySvgoUserDeposit, LazySvgoUserDown, LazySvgoUserEmail, LazySvgoUserFishing, LazySvgoUserGa, LazySvgoUserGooglePlay, LazySvgoUserHeadImg, LazySvgoUserIphone, LazySvgoUserKycCardFront, LazySvgoUserKycCardThird, LazySvgoUserKycInfo, LazySvgoUserKyc, LazySvgoUserLevel, LazySvgoUserMenu, LazySvgoUserPassword, LazySvgoUserSafety, LazySvgoUserSecretKey, LazySvgoUserSecurity, LazySvgoUserTransfer, LazySvgoUserUnverified, LazySvgoUserVerifyState, LazySvgoUserVerify, LazySvgoUserWithdraw } from '#components'
const lazyGlobalComponents = [
  ["SvgoAirdropArrow", LazySvgoAirdropArrow],
["SvgoAirdropDone", LazySvgoAirdropDone],
["SvgoAirdropIcFuturesAccount", LazySvgoAirdropIcFuturesAccount],
["SvgoAirdropIcGonggao", LazySvgoAirdropIcGonggao],
["SvgoAirdropIcHelp", LazySvgoAirdropIcHelp],
["SvgoAirdropIcLanguage", LazySvgoAirdropIcLanguage],
["SvgoAirdropIcNotebook", LazySvgoAirdropIcNotebook],
["SvgoAirdropIcTelegram", LazySvgoAirdropIcTelegram],
["SvgoAirdropIcX", LazySvgoAirdropIcX],
["SvgoApiManagementAdd", LazySvgoApiManagementAdd],
["SvgoApiManagementWarning", LazySvgoApiManagementWarning],
["SvgoAssetsIcAlert", LazySvgoAssetsIcAlert],
["SvgoAssetsIcCheck", LazySvgoAssetsIcCheck],
["SvgoAssetsIcEdit", LazySvgoAssetsIcEdit],
["SvgoAssetsIcNotebook", LazySvgoAssetsIcNotebook],
["SvgoAssetsStatusSuccess", LazySvgoAssetsStatusSuccess],
["SvgoAssetsWithdrawIcFail", LazySvgoAssetsWithdrawIcFail],
["SvgoAssetsWithdrawIcSuccess", LazySvgoAssetsWithdrawIcSuccess],
["SvgoCommonAppLightLogo", LazySvgoCommonAppLightLogo],
["SvgoCommonAppLogo", LazySvgoCommonAppLogo],
["SvgoCommonArrowDown", LazySvgoCommonArrowDown],
["SvgoCommonArrowRight", LazySvgoCommonArrowRight],
["SvgoCommonArrowUp", LazySvgoCommonArrowUp],
["SvgoCommonArrow", LazySvgoCommonArrow],
["SvgoCommonBtnLoading", LazySvgoCommonBtnLoading],
["SvgoCommonCheckCircle", LazySvgoCommonCheckCircle],
["SvgoCommonCheck", LazySvgoCommonCheck],
["SvgoCommonCodeQr", LazySvgoCommonCodeQr],
["SvgoCommonCopy", LazySvgoCommonCopy],
["SvgoCommonCopy2", LazySvgoCommonCopy2],
["SvgoCommonCopy3", LazySvgoCommonCopy3],
["SvgoCommonDateIcon", LazySvgoCommonDateIcon],
["SvgoCommonDelete", LazySvgoCommonDelete],
["SvgoCommonDownload", LazySvgoCommonDownload],
["SvgoCommonError", LazySvgoCommonError],
["SvgoCommonEyeClose", LazySvgoCommonEyeClose],
["SvgoCommonEye", LazySvgoCommonEye],
["SvgoCommonFilter", LazySvgoCommonFilter],
["SvgoCommonFire", LazySvgoCommonFire],
["SvgoCommonGuide", LazySvgoCommonGuide],
["SvgoCommonIconChevronDown", LazySvgoCommonIconChevronDown],
["SvgoCommonIconClear", LazySvgoCommonIconClear],
["SvgoCommonIconFavTrade", LazySvgoCommonIconFavTrade],
["SvgoCommonIconLogoQrWhite", LazySvgoCommonIconLogoQrWhite],
["SvgoCommonIconNotice", LazySvgoCommonIconNotice],
["SvgoCommonIconSearch", LazySvgoCommonIconSearch],
["SvgoCommonIconTip", LazySvgoCommonIconTip],
["SvgoCommonIconLogoQr", LazySvgoCommonIconLogoQr],
["SvgoCommonLoading", LazySvgoCommonLoading],
["SvgoCommonModalHint", LazySvgoCommonModalHint],
["SvgoCommonNoDataDark", LazySvgoCommonNoDataDark],
["SvgoCommonNoDataSearchDark", LazySvgoCommonNoDataSearchDark],
["SvgoCommonNoDataSearch", LazySvgoCommonNoDataSearch],
["SvgoCommonNoData", LazySvgoCommonNoData],
["SvgoCommonPagiationArrow", LazySvgoCommonPagiationArrow],
["SvgoCommonSearchClear", LazySvgoCommonSearchClear],
["SvgoCommonSelectArrow", LazySvgoCommonSelectArrow],
["SvgoCommonSolidTriangle", LazySvgoCommonSolidTriangle],
["SvgoCommonSuccess", LazySvgoCommonSuccess],
["SvgoCommonThemeDark", LazySvgoCommonThemeDark],
["SvgoCommonThemeLight", LazySvgoCommonThemeLight],
["SvgoCommonUsdt", LazySvgoCommonUsdt],
["SvgoCommonWaring2", LazySvgoCommonWaring2],
["SvgoCommonWarning", LazySvgoCommonWarning],
["SvgoCommonWarning3", LazySvgoCommonWarning3],
["SvgoContestArrowRight", LazySvgoContestArrowRight],
["SvgoContestAttention", LazySvgoContestAttention],
["SvgoContestCopy", LazySvgoContestCopy],
["SvgoContestCopyLink", LazySvgoContestCopyLink],
["SvgoContestDownload", LazySvgoContestDownload],
["SvgoContestFacebook", LazySvgoContestFacebook],
["SvgoContestIcInfo", LazySvgoContestIcInfo],
["SvgoContestIconDown", LazySvgoContestIconDown],
["SvgoContestLogo", LazySvgoContestLogo],
["SvgoContestOngoing", LazySvgoContestOngoing],
["SvgoContestShare", LazySvgoContestShare],
["SvgoContestTg", LazySvgoContestTg],
["SvgoContestTwitter", LazySvgoContestTwitter],
["SvgoFooterArrow", LazySvgoFooterArrow],
["SvgoFooterFacebook", LazySvgoFooterFacebook],
["SvgoFooterLinkedin", LazySvgoFooterLinkedin],
["SvgoFooterMedium", LazySvgoFooterMedium],
["SvgoFooterTelegram", LazySvgoFooterTelegram],
["SvgoFooterTiktok", LazySvgoFooterTiktok],
["SvgoFooterX", LazySvgoFooterX],
["SvgoFooterYoutube", LazySvgoFooterYoutube],
["SvgoFuturesBonus", LazySvgoFuturesBonus],
["SvgoFuturesBonusPosition", LazySvgoFuturesBonusPosition],
["SvgoFuturesCalculator", LazySvgoFuturesCalculator],
["SvgoFuturesDeliveringDark", LazySvgoFuturesDeliveringDark],
["SvgoFuturesDelivering", LazySvgoFuturesDelivering],
["SvgoFuturesHelp", LazySvgoFuturesHelp],
["SvgoFuturesIconStatusAlert", LazySvgoFuturesIconStatusAlert],
["SvgoFuturesIconTelegram", LazySvgoFuturesIconTelegram],
["SvgoFuturesIconTpslEdit", LazySvgoFuturesIconTpslEdit],
["SvgoFuturesIconX", LazySvgoFuturesIconX],
["SvgoFuturesKlineArea", LazySvgoFuturesKlineArea],
["SvgoFuturesKlineBars", LazySvgoFuturesKlineBars],
["SvgoFuturesKlineBaseline", LazySvgoFuturesKlineBaseline],
["SvgoFuturesKlineCandle", LazySvgoFuturesKlineCandle],
["SvgoFuturesKlineHeikinAshi", LazySvgoFuturesKlineHeikinAshi],
["SvgoFuturesKlineHilo", LazySvgoFuturesKlineHilo],
["SvgoFuturesKlineHollowCandle", LazySvgoFuturesKlineHollowCandle],
["SvgoFuturesKlineKagi", LazySvgoFuturesKlineKagi],
["SvgoFuturesKlineLineBreak", LazySvgoFuturesKlineLineBreak],
["SvgoFuturesKlineLine", LazySvgoFuturesKlineLine],
["SvgoFuturesKlinePointFigure", LazySvgoFuturesKlinePointFigure],
["SvgoFuturesKlineRenko", LazySvgoFuturesKlineRenko],
["SvgoFuturesMinusSign", LazySvgoFuturesMinusSign],
["SvgoFuturesModalInfo", LazySvgoFuturesModalInfo],
["SvgoFuturesPauseDark", LazySvgoFuturesPauseDark],
["SvgoFuturesPause", LazySvgoFuturesPause],
["SvgoFuturesPlusSign", LazySvgoFuturesPlusSign],
["SvgoFuturesResetLayout", LazySvgoFuturesResetLayout],
["SvgoFuturesRiskWidgetBg", LazySvgoFuturesRiskWidgetBg],
["SvgoFuturesRiskWidgetPointer", LazySvgoFuturesRiskWidgetPointer],
["SvgoFuturesSetting", LazySvgoFuturesSetting],
["SvgoFuturesTransferArrow", LazySvgoFuturesTransferArrow],
["SvgoFuturesTransferFuture", LazySvgoFuturesTransferFuture],
["SvgoFuturesTransferSpot", LazySvgoFuturesTransferSpot],
["SvgoFuturesTransferTrialfund", LazySvgoFuturesTransferTrialfund],
["SvgoFuturesTransfer", LazySvgoFuturesTransfer],
["SvgoHeaderIconAccount", LazySvgoHeaderIconAccount],
["SvgoHeaderIconApi", LazySvgoHeaderIconApi],
["SvgoHeaderIconApply", LazySvgoHeaderIconApply],
["SvgoHeaderIconArrowRight", LazySvgoHeaderIconArrowRight],
["SvgoHeaderIconCard", LazySvgoHeaderIconCard],
["SvgoHeaderIconChecked", LazySvgoHeaderIconChecked],
["SvgoHeaderIconClose", LazySvgoHeaderIconClose],
["SvgoHeaderIconContest", LazySvgoHeaderIconContest],
["SvgoHeaderIconDeposit", LazySvgoHeaderIconDeposit],
["SvgoHeaderIconFee", LazySvgoHeaderIconFee],
["SvgoHeaderIconFund", LazySvgoHeaderIconFund],
["SvgoHeaderIconFuturesAsset", LazySvgoHeaderIconFuturesAsset],
["SvgoHeaderIconFutures", LazySvgoHeaderIconFutures],
["SvgoHeaderIconInvite", LazySvgoHeaderIconInvite],
["SvgoHeaderIconLaunchpool", LazySvgoHeaderIconLaunchpool],
["SvgoHeaderIconLogout", LazySvgoHeaderIconLogout],
["SvgoHeaderIconNewAPI", LazySvgoHeaderIconNewAPI],
["SvgoHeaderIconOrder", LazySvgoHeaderIconOrder],
["SvgoHeaderIconPerpetual", LazySvgoHeaderIconPerpetual],
["SvgoHeaderIconSpotAsset", LazySvgoHeaderIconSpotAsset],
["SvgoHeaderIconSpot", LazySvgoHeaderIconSpot],
["SvgoHeaderIconTotalAsset", LazySvgoHeaderIconTotalAsset],
["SvgoHeaderIconTransfer", LazySvgoHeaderIconTransfer],
["SvgoHeaderIconUser", LazySvgoHeaderIconUser],
["SvgoHeaderIconWallet", LazySvgoHeaderIconWallet],
["SvgoHeaderIconWithdraw", LazySvgoHeaderIconWithdraw],
["SvgoHomeArrow", LazySvgoHomeArrow],
["SvgoHomeBanner", LazySvgoHomeBanner],
["SvgoHomeFutures", LazySvgoHomeFutures],
["SvgoHomeHot", LazySvgoHomeHot],
["SvgoHomeIcAndroid", LazySvgoHomeIcAndroid],
["SvgoHomeIcApple", LazySvgoHomeIcApple],
["SvgoHomeIcMore", LazySvgoHomeIcMore],
["SvgoHomeIcNotice", LazySvgoHomeIcNotice],
["SvgoHomeIcQrcode", LazySvgoHomeIcQrcode],
["SvgoHomeIcClose", LazySvgoHomeIcClose],
["SvgoHomeIcOpen", LazySvgoHomeIcOpen],
["SvgoHomeIcRightArrow", LazySvgoHomeIcRightArrow],
["SvgoHomeIcService", LazySvgoHomeIcService],
["SvgoHomeIconMore", LazySvgoHomeIconMore],
["SvgoHomeLogo", LazySvgoHomeLogo],
["SvgoHomeQrcode", LazySvgoHomeQrcode],
["SvgoHomeService", LazySvgoHomeService],
["SvgoHomeSpot", LazySvgoHomeSpot],
["SvgoHomeStep1", LazySvgoHomeStep1],
["SvgoHomeStep2", LazySvgoHomeStep2],
["SvgoHomeStep3", LazySvgoHomeStep3],
["SvgoHomeSupport", LazySvgoHomeSupport],
["SvgoHomeTop", LazySvgoHomeTop],
["SvgoHomeTrademethodsIcArrow", LazySvgoHomeTrademethodsIcArrow],
["SvgoHomeTrademethodsIcContest", LazySvgoHomeTrademethodsIcContest],
["SvgoHomeTrademethodsIcFutures", LazySvgoHomeTrademethodsIcFutures],
["SvgoHomeTrademethodsIcInvite", LazySvgoHomeTrademethodsIcInvite],
["SvgoHomeTrademethodsIcSpot", LazySvgoHomeTrademethodsIcSpot],
["SvgoInviteFriendsFailed", LazySvgoInviteFriendsFailed],
["SvgoInviteFriendsSuccess", LazySvgoInviteFriendsSuccess],
["SvgoInviteFriendsVerify", LazySvgoInviteFriendsVerify],
["SvgoJoinUsX", LazySvgoJoinUsX],
["SvgoJoinUsGroup", LazySvgoJoinUsGroup],
["SvgoJoinUsTg", LazySvgoJoinUsTg],
["SvgoKycAdd", LazySvgoKycAdd],
["SvgoKycCardBlackBg", LazySvgoKycCardBlackBg],
["SvgoKycCardWhiteBg", LazySvgoKycCardWhiteBg],
["SvgoKycDone", LazySvgoKycDone],
["SvgoKycIdCard", LazySvgoKycIdCard],
["SvgoKycPhone", LazySvgoKycPhone],
["SvgoKycUpload", LazySvgoKycUpload],
["SvgoLaunchpoolAdd", LazySvgoLaunchpoolAdd],
["SvgoLaunchpoolIcClear", LazySvgoLaunchpoolIcClear],
["SvgoLaunchpoolIcClock", LazySvgoLaunchpoolIcClock],
["SvgoLaunchpoolIcDownload", LazySvgoLaunchpoolIcDownload],
["SvgoLaunchpoolIcHelp", LazySvgoLaunchpoolIcHelp],
["SvgoLaunchpoolIcLeft", LazySvgoLaunchpoolIcLeft],
["SvgoLaunchpoolIcMenu", LazySvgoLaunchpoolIcMenu],
["SvgoLaunchpoolIcNotes", LazySvgoLaunchpoolIcNotes],
["SvgoLaunchpoolIcRights", LazySvgoLaunchpoolIcRights],
["SvgoLaunchpoolIcRightsText", LazySvgoLaunchpoolIcRightsText],
["SvgoLaunchpoolIcRule", LazySvgoLaunchpoolIcRule],
["SvgoLaunchpoolIconTrade", LazySvgoLaunchpoolIconTrade],
["SvgoLaunchpoolOfficialSite", LazySvgoLaunchpoolOfficialSite],
["SvgoLaunchpoolTagComingSoon", LazySvgoLaunchpoolTagComingSoon],
["SvgoLaunchpoolTagEnd", LazySvgoLaunchpoolTagEnd],
["SvgoLaunchpoolTagOnGoing", LazySvgoLaunchpoolTagOnGoing],
["SvgoLaunchpoolTwitter", LazySvgoLaunchpoolTwitter],
["SvgoLaunchpoolX", LazySvgoLaunchpoolX],
["SvgoLinksHeader", LazySvgoLinksHeader],
["SvgoMarketDarkSelected", LazySvgoMarketDarkSelected],
["SvgoMarketDarkUnselected", LazySvgoMarketDarkUnselected],
["SvgoMarketFavorite", LazySvgoMarketFavorite],
["SvgoMarketFuture", LazySvgoMarketFuture],
["SvgoMarketLightSelected", LazySvgoMarketLightSelected],
["SvgoMarketLightUnselected", LazySvgoMarketLightUnselected],
["SvgoMarketNoStar", LazySvgoMarketNoStar],
["SvgoMarketSearch", LazySvgoMarketSearch],
["SvgoMarketSpots", LazySvgoMarketSpots],
["SvgoMarketStar", LazySvgoMarketStar],
["SvgoMyIconsAccounts", LazySvgoMyIconsAccounts],
["SvgoMyIconsAssets", LazySvgoMyIconsAssets],
["SvgoMyIconsDeposit", LazySvgoMyIconsDeposit],
["SvgoMyIconsOrders", LazySvgoMyIconsOrders],
["SvgoMyIconsWithdraw", LazySvgoMyIconsWithdraw],
["SvgoMyWalletFuture", LazySvgoMyWalletFuture],
["SvgoMyWalletRecord", LazySvgoMyWalletRecord],
["SvgoMyWalletSpot", LazySvgoMyWalletSpot],
["SvgoReferralArrow", LazySvgoReferralArrow],
["SvgoReferralIcHow1", LazySvgoReferralIcHow1],
["SvgoReferralIcHow2", LazySvgoReferralIcHow2],
["SvgoReferralIcHow3", LazySvgoReferralIcHow3],
["SvgoReferralIcQrCode", LazySvgoReferralIcQrCode],
["SvgoReferralLogo", LazySvgoReferralLogo],
["SvgoSignUpArrow", LazySvgoSignUpArrow],
["SvgoSignUpCheck", LazySvgoSignUpCheck],
["SvgoSignUpClose", LazySvgoSignUpClose],
["SvgoSignUpCountryArrow", LazySvgoSignUpCountryArrow],
["SvgoSignUpEyeClose", LazySvgoSignUpEyeClose],
["SvgoSignUpEyeOpen", LazySvgoSignUpEyeOpen],
["SvgoSignUpPass", LazySvgoSignUpPass],
["SvgoSpotBg", LazySvgoSpotBg],
["SvgoSpotIcAdd", LazySvgoSpotIcAdd],
["SvgoSpotIcAttention", LazySvgoSpotIcAttention],
["SvgoSpotIcCalculatorS", LazySvgoSpotIcCalculatorS],
["SvgoSpotIcFire", LazySvgoSpotIcFire],
["SvgoSpotIcHistory", LazySvgoSpotIcHistory],
["SvgoSpotIcProfitSharing", LazySvgoSpotIcProfitSharing],
["SvgoSpotIcWebsite", LazySvgoSpotIcWebsite],
["SvgoSpotIcWhitePaper", LazySvgoSpotIcWhitePaper],
["SvgoSpotIcZoomout", LazySvgoSpotIcZoomout],
["SvgoSpotIconCamera", LazySvgoSpotIconCamera],
["SvgoSpotIconFullscreen", LazySvgoSpotIconFullscreen],
["SvgoSpotIconIcRight", LazySvgoSpotIconIcRight],
["SvgoSpotIconIndicators", LazySvgoSpotIconIndicators],
["SvgoSpotIconSetting", LazySvgoSpotIconSetting],
["SvgoTokenListingApplyArrow", LazySvgoTokenListingApplyArrow],
["SvgoTokenListingApplySelected", LazySvgoTokenListingApplySelected],
["SvgoUserAdvancedcertification", LazySvgoUserAdvancedcertification],
["SvgoUserAlert", LazySvgoUserAlert],
["SvgoUserApple", LazySvgoUserApple],
["SvgoUserBasiccertification", LazySvgoUserBasiccertification],
["SvgoUserCertificationstatus", LazySvgoUserCertificationstatus],
["SvgoUserCheck", LazySvgoUserCheck],
["SvgoUserCircle", LazySvgoUserCircle],
["SvgoUserClose", LazySvgoUserClose],
["SvgoUserDel", LazySvgoUserDel],
["SvgoUserDeposit", LazySvgoUserDeposit],
["SvgoUserDown", LazySvgoUserDown],
["SvgoUserEmail", LazySvgoUserEmail],
["SvgoUserFishing", LazySvgoUserFishing],
["SvgoUserGa", LazySvgoUserGa],
["SvgoUserGooglePlay", LazySvgoUserGooglePlay],
["SvgoUserHeadImg", LazySvgoUserHeadImg],
["SvgoUserIphone", LazySvgoUserIphone],
["SvgoUserKycCardFront", LazySvgoUserKycCardFront],
["SvgoUserKycCardThird", LazySvgoUserKycCardThird],
["SvgoUserKycInfo", LazySvgoUserKycInfo],
["SvgoUserKyc", LazySvgoUserKyc],
["SvgoUserLevel", LazySvgoUserLevel],
["SvgoUserMenu", LazySvgoUserMenu],
["SvgoUserPassword", LazySvgoUserPassword],
["SvgoUserSafety", LazySvgoUserSafety],
["SvgoUserSecretKey", LazySvgoUserSecretKey],
["SvgoUserSecurity", LazySvgoUserSecurity],
["SvgoUserTransfer", LazySvgoUserTransfer],
["SvgoUserUnverified", LazySvgoUserUnverified],
["SvgoUserVerifyState", LazySvgoUserVerifyState],
["SvgoUserVerify", LazySvgoUserVerify],
["SvgoUserWithdraw", LazySvgoUserWithdraw],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
